import React, {useState, useEffect, useRef} from 'react';
import {withTranslation} from 'react-i18next';
import {DataTable} from 'primereact/datatable';
import {Column} from 'primereact/column';
import {Dropdown} from "primereact/dropdown";
import axios from "axios";
import {InputMask} from "primereact/inputmask";
import moment from "moment/moment";

const ExchangerateListComponent = (props) => {

  const {t} = props;
  const [exchangerates, setExchangerates] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);
  const [rows, setRows] = useState(Number(process.env.REACT_APP_LIST_ROW_DEFAULT));
	const [dateFrom, setDateFrom] = useState('');
	const [dateTo, setDateTo] = useState('');
	const [appliedDateFrom, setAppliedDateFrom] = useState('');
	const [appliedDateTo, setAppliedDateTo] = useState('');
	const [dateInvalid, setDateInvalid] = useState({
		dateFrom: false,
		dateTo: false,
	});
  const dt = useRef(null);
  const [lazyParams, setLazyParams] = useState({
    first: 0,
    rows: rows,
    page: 0,
    sortField: 'id',
    sortOrder: -1,
  });

  const loadLazyTimeout = useRef(null);
  const loadLazyData = () => {
    setLoading(true);
    if (loadLazyTimeout.current) {
			clearTimeout(loadLazyTimeout.current);
		}
		loadLazyTimeout.current = setTimeout(() => {
			let query = window.App.transformQueryParams(lazyParams);
			let dateQuery = '';
			const fromValid = appliedDateFrom && isValidDateString(appliedDateFrom);
			const toValid = appliedDateTo && isValidDateString(appliedDateTo);

      if (fromValid && toValid) {
				dateQuery = `search[date][operator]=between&search[date][value]=${appliedDateFrom} 00:00:00,${appliedDateTo} 23:59:59`;
			} else if (fromValid) {
				dateQuery = `search[date][operator]=>=&search[date][value]=${appliedDateFrom} 00:00:00`;
			} else if (toValid) {
				dateQuery = `search[date][operator]=<=&search[date][value]=${appliedDateTo} 23:59:59`;
			}
      if (dateQuery) query += `${query.includes('?') ? '&' : '?'}${dateQuery}`;
      apiCall('get', '/api/v2/exchange-rate' + query)
        .then(response => {
          setTotalRecords(response.data.data.total_item_count);
          setExchangerates(response.data.data.items)
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    }, Math.random() * 1000 + 250);
  }
  const onPage = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    setLazyParams(_lazyParams);
  }
  const onSort = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    setLazyParams(_lazyParams);
  }
  const onFilter = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    _lazyParams['first'] = 0;
    _lazyParams['page'] = 0;
    setLazyParams(_lazyParams);
  }
  const pager = {
    layout: 'RowsPerPageDropdown CurrentPageReport PrevPageLink NextPageLink',
    'RowsPerPageDropdown': (options) => {
      const dropdownOptions = [
        {label: Number(process.env.REACT_APP_LIST_ROW_OP1), value: Number(process.env.REACT_APP_LIST_ROW_OP1)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP2), value: Number(process.env.REACT_APP_LIST_ROW_OP2)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP3), value: Number(process.env.REACT_APP_LIST_ROW_OP3)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP4), value: Number(process.env.REACT_APP_LIST_ROW_OP4)},
      ];

      return (
        <>
          {/*<span className="p-mx-1" style={{color: 'var(--text-color)', userSelect: 'none'}}>Tételek egy oldalon: </span>*/}
          <Dropdown value={options.value} options={dropdownOptions} onChange={(e) => setRows(e.target.value)}
                    appendTo={document.body}/>
        </>
      );
    },
    'CurrentPageReport': (options) => {
      return (
        <span style={{color: 'var(--text-color)', userSelect: 'none', width: '120px', textAlign: 'center'}}>
                        {options.first} - {options.last} / {options.totalRecords}
        </span>
      )
    }
  };

  const apiCall = (method, url, data) => {
    return axios({
      method: method,
      url: process.env.REACT_APP_API_HOST + url,
      data,
      params: {},
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      }
    })
  }

  // const actionBodyTemplate = (rowData) => {
  //   return (
  //     <React.Fragment>
  //       {localStorage.getItem('roles').toString().includes('role_') &&
  //         <Button icon="pi pi-pencil" className="  p-button-warning p-mr-2"
  //                 tooltip={t('edit')} tooltipOptions={{position: 'left'}}
  //                 onClick={() => {
  //                   if(entity === 'exchangerate') {
  //                     history.push('/inventory/exchange-rate/update/' + rowData.id)
  //                   }
  //                 }}/>
  //       }
  //       {localStorage.getItem('roles').toString().includes('role_') &&
  //         <Button icon="pi pi-trash" className="p-button-danger"
  //                 tooltip={t('delete')} tooltipOptions={{position: 'left'}}
  //                 onClick={() => {
  //                   if (window.confirm('A törlés megerősítésére van szükség!')) {
  //                     setLoading(true);
  //                     apiCall('delete', '/api/v2/exchange-rate/' + rowData.id)
  //                       .then(response => {
  //                         window.App.toastShow('success', 'Sikeres törlés!');
  //                         window.App.setState({rerenderExchangerateList: Math.random()})
  //                       })
  //                       .catch(error => {
  //                         window.App.toastShow('error', t('error'), error.toString(), '', error.response);
  //                       })
  //                       .finally(() => {
  //                         setLoading(false);
  //                       })
  //                   }
  //                 }}
  //         />
  //       }
  //     </React.Fragment>
  //   );
  // }

	const dateFilterTemplate = () => (
		<div className="p-grid p-ai-center p-m-0 p-fluid" style={{ minWidth: '16rem' }}>
			<div className="p-col p-p-0">
				<InputMask value={dateFrom} mask="9999-99-99" placeholder={t('datePlaceholder')}className="p-inputtext-sm" onChange={(e) => handleMaskedDateChange(e.value, setDateFrom, 'dateFrom')} />
			</div>
			<div className={"p-col-2 p-text-center p-col-align-center p-px-0"}>
				<i className={"pi pi-arrow-left"}></i> <i className={"pi pi-arrow-right"}></i>
			</div>
			<div className="p-col p-p-0">
				<InputMask value={dateTo} mask="9999-99-99" placeholder={t('datePlaceholder')}className="p-inputtext-sm" onChange={(e) => handleMaskedDateChange(e.value, setDateTo, 'dateTo')} />
			</div>
		</div>
	);

	const isValidDateString = (value) => {
		if (!value || value.includes('_')) {
			return false;
		}
		return moment(value, 'YYYY-MM-DD', true).isValid();
	};

	const handleMaskedDateChange = (value, setter, key) => {
		const currentValue = key === 'dateFrom' ? dateFrom : dateTo;
		const currentAppliedValue = key === 'dateFrom' ? appliedDateFrom : appliedDateTo;
		if (value === currentValue) {
			return;
		}
		setter(value);
		const empty = !value || value.replace(/_/g, '').trim() === '';
		const valid = isValidDateString(value);
		setDateInvalid(prev => ({
			...prev,
			[key]: !empty && !valid,
		}));
		if (empty || valid) {
			const nextAppliedValue = empty ? '' : value;
			if (nextAppliedValue !== currentAppliedValue) {
				if (key === 'dateFrom') {
					setAppliedDateFrom(nextAppliedValue);
				}
				if (key === 'dateTo') {
					setAppliedDateTo(nextAppliedValue);
				}
				setLazyParams(prev => {
					if (prev.first === 0 && prev.page === 0) {
						return prev;
					}
					return {
						...prev,
						first: 0,
						page: 0,
					};
				});
			}
		}
	};

  useEffect(() => {
    loadLazyData();
  }, [lazyParams, appliedDateFrom, appliedDateTo, window.App.state.rerenderExchangerateList])

  return (
    <>
      <DataTable size={localStorage.getItem('scale')}
                 emptyMessage={t('noResults')}
                 value={exchangerates} paginator first={lazyParams.first} totalRecords={totalRecords} onPage={onPage}
                 onSort={onSort} sortField={lazyParams.sortField} sortOrder={lazyParams.sortOrder}
                 onFilter={onFilter} filters={lazyParams.filters} loading={loading} lazy
                 paginatorTemplate={pager} rows={rows}
                 autoLayout={true}
                 filterDisplay="row"
                 responsiveLayout="scroll"
                 stripedRows
                 ref={dt}
                 dataKey="id"
      >
        <Column field="provider" header="Árfolyamforrás" sortable filter/>
        <Column field="currency" header={t('columnCurrency')} sortable filter></Column>
				<Column field="rate" header={t('columnExchangeRate')} sortable></Column>




        <Column field="date" header={t('columnDate')} sortable filter filterMatchMode='between' filterElement={dateFilterTemplate} body={(rowData) => {
          return (
            <>{window.App.formatDateValue(rowData.date)}</>
          )
        }}></Column>
        {/* <Column body={actionBodyTemplate} className={"p-py-0 p-text-right p-text-nowrap"}></Column> */}
      </DataTable>
    </>
  )
}
export default withTranslation('common')(ExchangerateListComponent);
